import { z } from 'zod';

import { Email, ProfileId } from 'backend-client-web';

import { undefinedFromNullish } from '../util/undefinedFromNullish';

interface RelatedProfile {
  id: ProfileId;
  email: Email | undefined;
}

const RelatedProfile = z.object({
  id: z.uuid(),
  email: undefinedFromNullish(z.string()),
});

export { RelatedProfile };
